import { Planning } from '../progress-accordions/Planning';
import { Action } from '../progress-accordions/Action';
import { Reflect } from '../progress-accordions/Reflect';
import { ProgressStepStatusEnum, TeamProjectHubResponse } from '@platform/client/schemas';
import { HubProgressHeader } from '../shared-components/HubProgressHeader';

export const TeamProgressAccordions = ({ hubData }: { hubData: TeamProjectHubResponse }) => {
  const { progress, userType, project } = hubData;
  const completedSteps = Object.values(progress).filter(
    (status) =>
      status === ProgressStepStatusEnum.success ||
      status === ProgressStepStatusEnum.inactive_in_progress,
  ).length;
  const totalSteps = Object.keys(progress).length;
  return (
    <>
      <HubProgressHeader
        completed={completedSteps}
        total={totalSteps}
        project={project}
        allowDateEdit={userType === 'PROFESSIONAL' && hubData.status === 'Matched'}
        includeDates={true} // team projects do not have a discovery phase
      />
      <Planning
        status={progress.plan}
        isTeam={true}
        userType={userType}
        projectId={project?.id}
        planningGuideUrl={hubData.planningGuideUrl}
      />
      <Action
        status={progress.action}
        isTeam={true}
        userType={userType}
        projectId={project?.id}
        planningGuideUrl={hubData.planningGuideUrl}
      />
      <Reflect
        status={progress.reflect}
        isTeam={true}
        userType={userType}
        surveyUrl={hubData.surveyUrl}
        storyUrl={hubData.storyUrl}
      />
    </>
  );
};
